import styled from "styled-components";

export const GeneralImageRatingContainer = styled.div`
  display: flex;
  justify-content: center;
`;
